<div class="course-container" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1 auto" fxLayoutGap="36px">
	<loader [loader]="loader" [type]="'general'"></loader>
	<div class="course-detail" fxFlex="1 1 auto" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
		<ng-container *ngIf="resourceDetail?.description">
			<div class="descrip-block">
				<app-readability [length]="200" [canRead]="true" [height]="(resourceDetail?.description) ? '18' : '0'">
					<content>
						{{resourceDetail?.description}}
					</content>
				</app-readability>
			</div>
		</ng-container>
		<div class="course-view" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="32px"
			fxLayoutGap.xs="10px">
			<div fxFlex="0 1 350px" fxFlex.xs="1 1" class="thumbnail-block">
				<div class="thumbnail">
					<img [src]="resourceDetail?.resource?.thumbnail"
						(error)="gfService.setErrorImage($event, 'broken_image')" alt="">
				</div>
			</div>
			<div class="course-content" fxFlex="0 1 414px" fxFlex.xs="1 1" fxLayout="column"
				fxLayoutAlign="start stretch" fxLayoutGap="5px" fxFlayoutGap.xs="5px">
				<!-- <ng-container *ngIf="resourceDetail?.title"> -->
				<div class="course-list" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="18px">
					<div fxFlex="1 0" class="course-item" fxLayout="column" fxLayoutAlign="start stretch"
						fxLayoutGap="18px">
						<div fxLayout="row" fxLayoutGap="5px" fxFlayoutGap.xs="5px" fxLayoutAlign="start center">
							<mat-icon class="main-icon">timer</mat-icon>
							<span class="sub-caption-3">{{ resourceDetail?.infoFields?.course?.courseDurationInHrs + '
								Hrs'}}</span>
						</div>
						<ng-container *ngIf="resourceDetail?.completedPercent < 100">
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<span class="body-text">{{ locale.translate('certification_score') }}</span>
								<span class="score-dtls">{{resourceDetail?.infoFields?.course?.minScoreForCertification
									|| 0}}%</span>
							</div>
						</ng-container>
						<ng-container
							*ngIf="['manageCourse_published', 'manageCourse_requests', 'manageCourse_drat', 'manageCourse_archives'].includes(resourceDetail?.actionFrom) && resourceDetail?.status?.key !== 'published'">
							<div fxLayout="column" fxLayoutAlign="start stretch">
								<span
									class="body-text">{{locale.translate('this_course_has_not_been_published')}}</span>
							</div>
						</ng-container>
					</div>

					<ng-container
						*ngIf="resourceDetail?.resourceAction.enrollments || resourceDetail?.resourceAction.enroll || resourceDetail?.resourceAction.nominate || resourceDetail?.resourceAction.takeCourse">
						<div class="course-item" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">
							<ng-container
								*ngIf="resourceDetail?.resourceAction.enrollments || resourceDetail?.resourceAction.enroll || resourceDetail?.resourceAction.nominate">
								<div class="button-block" fxLayout="row wrap" fxLayoutAlign="start center"
									fxLayoutGap="10px">
									<ng-container *ngIf="resourceDetail?.resourceAction.enroll">
										<ng-container *ngIf="resourceDetail?.requestAwaitingApproval === 0">
											<!-- <ng-container *ngIf="resourceDetail?.infoFields?.course?.enrolment === 'anyone'"> -->
											<button mat-stroked-button class="action-prime-btn"

												#enrolActivityAction
												(click)="alertPopup('enrollActivity', {
													actionElement: enrolActivityAction
												})"
												
												>
												{{ locale.translate('enroll') }}
											</button>
											<!-- </ng-container> -->
										</ng-container>
										<ng-container *ngIf="resourceDetail?.requestAwaitingApproval === 1">
											<span
												class="body-text">{{locale.translate('your_request_awaiting_approval')}}
											</span>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceAction.enrollments">
										<button mat-stroked-button class="action-prime-btn"
											(click)="enrollments(enrollmentsEl)" #enrollmentsEl>
											{{ locale.translate('enrollments') }}
										</button>
									</ng-container>
									<ng-container *ngIf="resourceDetail?.resourceAction.nominate">
										<button mat-stroked-button class="action-prime-btn"
											(click)="nominate(nominateEl)" #nominateEl>
											{{ locale.translate('nominate') }}
										</button>
									</ng-container>
								</div>
							</ng-container>

							<!---mycode-->
							<ng-container *ngIf="resourceDetail?.resourceAction.takeCourse">
								<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
									<div fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="15px"
										fxLayoutGap.xs="10px">
										<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
											<div class="enroll-course" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="0px" fxLayoutGap.xs="8px">
												<ng-container *ngIf="resourceDetail?.completedPercent >= 100">
													<p class="body-text">
														{{locale.translate('you_have_completed_this_course') }}
													</p>
												</ng-container>
												<ng-container *ngIf="resourceDetail?.completedPercent < 100">
													<p class="body-text">{{locale.translate('enrolled_course') }}
													</p>
												</ng-container>
											</div>
											<!--progress bar-->
											<ng-container *ngIf="resourceDetail?.completedPercent < 100">
												<div class="progress-dtls" fxLayout="row" fxLayoutAlign="center center">
													<mat-progress-bar fxFlex="0 1 200px" class="progress-br"
														color="primary" mode="determinate"
														[value]="resourceDetail?.completedPercent">
													</mat-progress-bar>
												</div>
											</ng-container>
											<!--end-->
											<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
												<ng-container
													*ngIf="resourceDetail?.completedPercent >= 100 && resourceDetail?.scoredPercentage">
													<p class="completion-percent">{{resourceDetail?.scoredPercentage}}%
													</p>
												</ng-container>
												<ng-container
													*ngIf="resourceDetail?.completedPercent >= 100 && resourceDetail?.scoredPercentage && resourceDetail?.scoredPercentage < resourceDetail?.infoFields?.course?.minScoreForCertification">
													<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
														<p class="sub-txt-patch error">
															{{locale.translate('not_eligible_for_certification')}}</p>
													</div>
												</ng-container>
											</div>
										</div>
										<div class="button-block" fxLayout="row" fxLayoutAlign="start center"
											fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="start stretch">
											<button mat-stroked-button class="action-prime-btn" (click)="learn()">
												<ng-container *ngIf="resourceDetail?.completedPercent < 100">
													{{ locale.translate('learn') }}
												</ng-container>
												<ng-container *ngIf="resourceDetail?.completedPercent >= 100">
													{{ locale.translate('open') }}
												</ng-container>
											</button>
										</div>
									</div>
									<ng-container *ngIf="resourceDetail?.enrollmentDetail?.enrolmentDate">
										<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
											<app-common-view class="caption"
															[data]="{label: locale.translate('enrolled_on'), value: resourceDetail?.enrollmentDetail?.enrolmentDate}">
											</app-common-view>
											<ng-container *ngIf="resourceDetail?.enrollmentDetail?.completionDate">
												<app-common-view class="caption"
															[data]="{label: locale.translate('completed_on'), value: resourceDetail?.enrollmentDetail?.completionDate}">
												</app-common-view>
											</ng-container>
											
										</div>
									</ng-container>
									<!-- <ng-container
										*ngIf="resourceDetail?.completedPercent >= 100 && !resourceDetail?.scoredPercentage">
										<div fxLayout="row" fxLayoutAlign="start center">
											<p class="sub-txt-patch waiting">{{locale.translate('awaiting_evaluation')}}
											</p>
										</div>
									</ng-container> -->
									<ng-container
										*ngIf="resourceDetail?.scoredPercentage && resourceDetail?.scoredPercentage >= resourceDetail?.infoFields?.course?.minScoreForCertification">
										<div class="button-block" fxLayout="row wrap" fxLayoutAlign="start center"
											fxLayoutGap="10px" fxLayout.xs="column" fxLayoutAlign.xs="center center">
											<ng-container
												*ngIf="resourceDetail?.enrollmentDetail?.certificateGeneratedDate">
												<button mat-stroked-button class="action-prime-btn" #viewCertificateEl
													(click)="viewCertificate(viewCertificateEl)">
													{{ locale.translate('view_certificate') }}
												</button>
											</ng-container>
											<ng-container
												*ngIf="!resourceDetail?.enrollmentDetail?.certificateGeneratedDate">
												<button mat-stroked-button class="action-prime-btn"
													#generateCertificateEl
													(click)="generateCertificate(generateCertificateEl)">
													{{ locale.translate('generate_certificate') }}
												</button>
											</ng-container>
											<!-- <button mat-stroked-button class="action-prime-btn">
								View Certificate
							</button> -->
										</div>
									</ng-container>
								</div>
							</ng-container>
							<!---end-->
						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
	<div class="feature-placeholder fx-column fx-start-stretch"
		[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
	</div>
	<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="5px" class="course-content-collapsible-block">
		<app-collapsible-area [data]="{title: locale.translate('skills_covered')}" #collapsibleElement
			[toggle]="{expanded: false, showToggle: true}" color="#fff"
			(opened)="collapsibleToggle($event, collapsibleElement)">
			<div class="competency-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">
				<!-- <span class="comp-title">{{ locale.translate('project_desc') }}</span> -->
				<ng-container *ngIf="!resourceDetail?.skills?.length">
					<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
						<p class="no-data">{{locale.translate('no_skills_defined')}}</p>
					</div>
				</ng-container>
				<ng-container *ngIf="resourceDetail?.skills?.length">
					<div class="comp-list" fxLayout="row wrap" fxLayoutAlign="start center"
						fxLayoutAlign.xs="start stretch">
						<ng-container *ngFor="let skill of resourceDetail?.skills">
							<div class="comp-item">
								<app-chips type="progressive"
									[data]="{title: skill?.skill?.value, progress:  skill?.skillLevel + '%', toolTip: true}">
								</app-chips>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</app-collapsible-area>
		<app-collapsible-area [data]="{title: locale.translate('prerequisites')}" #collapsibleElement
			[toggle]="{expanded: false, showToggle: true}" color="#fff"
			(opened)="collapsibleToggle($event, collapsibleElement)">
			<div class="prerequest-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="17px">
				<!-- <ng-container *ngIf="resourceDetail?.description">
					<span class="prerequest-desc">
						{{resourceDetail?.description}}
					</span>
				</ng-container> -->
				<ng-container *ngIf="!resourceDetail?.infoFields?.course?.prerequisiteSkills?.length">
					<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
						<p class="no-data">{{locale.translate('nothing_to_show')}}</p>
					</div>
				</ng-container>
				<ng-container *ngIf="resourceDetail?.infoFields?.course?.prerequisiteSkills?.length">
					<div class="prerequest-list" fxLayout="row wrap" fxLayoutAlign="start center"
						fxLayoutAlign.xs="start stretch">
						<ng-container *ngFor="let skill of resourceDetail?.infoFields?.course?.prerequisiteSkills">
							<div class="prerequest-item">
								<app-chips type="progressive"
									[data]="{title: skill?.skillName, progress: skill?.skillLevel + '%', toolTip: true}">
								</app-chips>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</div>
		</app-collapsible-area>
		<app-collapsible-area [data]="{title: locale.translate('contents')}" #collapsibleElement
			[toggle]="{expanded: contentOpened, showToggle: true}" color="#fff"
			(opened)="collapsibleToggle($event, collapsibleElement);contentOpened = $event">
			<!-- <div header-insight class="col-header">
				<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0px" fxFlex="1 0">
					<div class="common-icon" fxLayout="row" fxLayoutGap="10px">
						<ng-container *ngIf="!canAddModule && contentOpened && canUpdate">
							<button mat-icon-button class="icon-btn" (click)="canAddModule = true">
								<mat-icon svgIcon="edit"></mat-icon>
							</button>
						</ng-container>
					</div>
				</div>
			</div> -->
			<div class="resource-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">
				<div class="collapsible-container" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px"
					fxLayoutGap.xs="20px">
					<ng-container *ngIf="canAddModule && resourceDetail?.resourceAction?.addModule">
						<div class="btn-block" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">

							<div fxLayout="row" fxLayoutAlign="start center" (click)="addModule()">
								<span class="hyperlink">{{locale.translate('add_module')}}</span>
							</div>

							<!-- <button mat-stroked-button class="prime-btn" #addAssessmentActionEl
								(click)="addAssessment(addAssessmentActionEl)">
								<div fxLayout="row" fxLayoutAlign="start center">
									<span>{{locale.translate('add_assessment')}}</span>
								</div>
							</button> -->
						</div>
					</ng-container>
					<ng-container *ngIf="!resourceDetail?.infoFields?.courseModules?.length">
						<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="15px">
							<p class="no-data">{{locale.translate('no_modules_defined')}}</p>
						</div>
					</ng-container>
					<ng-container *ngIf="resourceDetail?.infoFields?.courseModules?.length">
						<div class="module-list" fxLayout="column" fxLayoutAlign="start stretch" cdkDropList
							[cdkDropListData]="resourceDetail?.infoFields?.courseModules"
							(cdkDropListDropped)="drop($event, resourceDetail?.infoFields?.courseModules, 'courseModule')"
							[cdkDropListDisabled]="!(resourceDetail?.infoFields?.courseModules?.length > 1 && canUpdate && canAddModule &&
							detectDevice?.resolutionState$?.value?.deviceType !== 'mobile')">
							<ng-container *ngIf="resourceDetail?.infoFields?.courseModules?.length">
								<ng-container
									*ngFor="let data of resourceDetail?.infoFields?.courseModules; trackBy: gfService.trackByID.bind({'key': 'moduleID'});let i = index">
									<div class="module-item" fxLayout="column" fxLayoutAlign="start stretch"
										[ngClass]="{'dragging': data?.dragging}" cdkDrag cdkDragBoundary=".module-list"
										(cdkDragStarted)="cdkDragStarted($event, data)"
										(cdkDragEnded)="cdkDragEnded($event, data)">
										<div class="module-dragger-placeholder" *cdkDragPlaceholder></div>
										<div fxFlex="1 1" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="12px">
											<ng-container *ngIf="resourceDetail?.infoFields?.courseModules?.length > 1 && canUpdate && canAddModule &&
												detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'">
												<mat-icon svgIcon="drag_and_drop" class="module-drag-icon"
													cdkDragHandle></mat-icon>
											</ng-container>
											<app-collapsible-block class="collapsible-block"
												[ngClass]="{ 'processing': data?.deleting}"
												[data]="{title:data?.moduleName}"
												[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
												radius="5px" color="transparent" borderColor="var(--secondary-three)"
												(opened)="data.opened = $event">

												<div header-insight class="comp-header">
													<div fxLayout="row" fxLayoutAlign="start center"
														fxLayoutAlign.xs="space-between center" fxLayoutGap="10px"
														fxFlex="1 0">
														<ng-container
															*ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop' && data?.opened && resourceDetail?.resourceAction?.addModule && canAddModule">
															<button class="icon-btn" mat-icon-button #editActionEl
																(click)="updateModule(data, editActionEl)">
																<mat-icon class="header-icon" svgIcon="edit"></mat-icon>
															</button>
															<button class="icon-btn" mat-icon-button #deleteAction
																(click)="alertPopup('deleteModule', data, {
												actionElement: deleteAction, index: i
											})">
																<mat-icon class="header-icon" svgIcon="delete">
																</mat-icon>
															</button>
														</ng-container>
														<p class="body-text">
															{{(data?.activites?.length + data?.references?.length) ||
															0}}
														</p>
														<ng-container
															*ngIf="detectDevice?.resolutionState$?.value?.deviceType !== 'desktop' && data?.opened && resourceDetail?.resourceAction?.addModule && canAddModule">
															<button class="icon-btn" mat-icon-button
																[matMenuTriggerFor]="menu"
																aria-label="Example icon-button with a menu">
																<mat-icon class="header-icon">more_vert</mat-icon>
															</button>
															<mat-menu #menu="matMenu">
																<button mat-menu-item (click)="updateModule(data)">
																	<span>{{locale.translate('edit')}}</span>
																</button>
																<button mat-menu-item (click)="alertPopup('deleteModule', data, {
													index: i
												})">
																	<span>{{locale.translate('delete')}}</span>
																</button>
															</mat-menu>
														</ng-container>
													</div>
												</div>
												<div class="sub-content-area" fxLayout="column"
													fxLayoutAlign="start stretch" fxLayoutGap="8px" fxLayoutGap.xs="5px"
													fxLayoutAlign.xs="start stretch">
													<div class="lock-caption" fxLayoutGap="10px" fxLayout="row" fxLayoutAlign="start center">
														<ng-container *ngIf="data?.unlockAfterPrevious">
															<p class="sub-caption-1"> {{locale.translate('after_previous')}}</p>	
													   </ng-container>
													   	<p class="sub-caption-1" *ngIf="data?.unlockAfterPrevious && data?.sequenceActivities">|</p>
														<ng-container *ngIf="data?.sequenceActivities">
															 <p class="sub-caption-1">{{locale.translate('enforce_sequencing')}}</p>	
														</ng-container>
													</div>
													<ng-container *ngIf="resourceDetail?.resourceAction?.addActivity">
														<div class="add-activity" fxLayoutAlign="start center">
															<p class="hyperlink" (click)="chooseContentType(data)">
																{{locale.translate('add_activity')}}</p>
														</div>
													</ng-container>
													<ng-container *ngIf="data?.activites?.length">
														<div fxLayout="row" fxLayoutAlign="start stretch">

															<div fxFlex="0 1 714px" fxFlex.xs="1 1">
																<div class="activity-list" fxLayout="column"
																	fxLayoutAlign="start stretch" fxLayoutGap="0px"
																	fxLayoutGap.xs="10px" cdkDropList
																	[cdkDropListData]="data?.activites"
																	(cdkDropListDropped)="drop($event, data?.activites, 'activity', i)"
																	[cdkDropListDisabled]="!(data?.activites?.length > 1 && canUpdate && canAddModule &&
																detectDevice?.resolutionState$?.value?.deviceType !== 'mobile')">
																	<ng-container
																		*ngFor="let activity of data?.activites; trackBy: gfService.trackByID.bind({'key': 'id'});let activityIndex = index">
																		<div class="activity-dragger-item"
																			fxLayout="column" fxLayoutGap="5px"
																			[ngClass]="{'dragging': data?.dragging}"
																			cdkDrag cdkDragBoundary=".activity-list"
																			(cdkDragStarted)="cdkDragStarted($event, data)"
																			(cdkDragEnded)="cdkDragEnded($event, data)">
																			<div class="activity-dragger-placeholder"
																				*cdkDragPlaceholder></div>
																			<div fxLayout="row"
																				fxLayoutAlign="start center"
																				fxLayoutGap="10px">
																				<ng-container *ngIf="data?.activites?.length > 1 && resourceDetail?.resourceAction?.organize && canAddModule &&
																					detectDevice?.resolutionState$?.value?.deviceType !== 'mobile'">
																					<mat-icon svgIcon="drag_and_drop"
																						class="drag-icon" cdkDragHandle>
																					</mat-icon>
																				</ng-container>
																				<div class="activity-content"
																					fxFlex="1 1" fxLayout="row"
																					fxLayoutAlign="space-between center"
																					[ngClass]="{ 'processing': activity?.deleting}">
																					<div fxLayout="row"
																						fxLayoutAlign="start center"
																						fxLayoutGap="18px">

																						<ng-container
																							*ngIf="activity?.type === 'AT'">
																							<mat-icon
																								class="common-icon"
																								[svgIcon]="activity?.contentType?.svgIcon">
																							</mat-icon>
																						</ng-container>
																						<ng-container
																							*ngIf="activity?.type !== 'AT'">
																							<ng-container
																								*ngIf="!['internalEvent', 'externalEvent', 'mooc'].includes(activity?.resourceTypeID?.key)">
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'video'">
																									<mat-icon
																										svgIcon="video_camera"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'audio'">
																									<mat-icon
																										svgIcon="audio_headphone"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'page'">
																									<mat-icon
																										svgIcon="pages"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'link'">
																									<mat-icon
																										svgIcon="external_link"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'document'">
																									<mat-icon
																										svgIcon="document"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'image'">
																									<mat-icon
																										svgIcon="image_collection"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																								<ng-container
																									*ngIf="activity?.resourceFormat?.key === 'scorm'">
																									<mat-icon
																										svgIcon="scorm"
																										class="common-icon">
																									</mat-icon>
																								</ng-container>
																							</ng-container>
																							<ng-container
																								*ngIf="['internalEvent', 'externalEvent'].includes(activity?.resourceTypeID?.key)">
																								<mat-icon
																									svgIcon="events"
																									class="common-icon">
																								</mat-icon>
																							</ng-container>
																							<ng-container
																								*ngIf="['mooc'].includes(activity?.resourceTypeID?.key)">
																								<mat-icon
																									svgIcon="course"
																									class="common-icon">
																								</mat-icon>
																							</ng-container>
																						</ng-container>
																						<span class="entity-title"
																							*ngIf="activity?.type == 'AT'">{{activity?.title}}</span>
																						<ng-container *ngIf="activity?.type !== 'AT'"> 
																							<span class="entity-title hyperlink"
																							(click)="viewActivity(activity.id)" >{{activity?.title}}</span>
																						</ng-container>
																					</div>
																					<ng-container
																						*ngIf="resourceDetail?.resourceAction?.addActivity && canAddModule">
																						<div>
																							<ng-container
																								*ngIf="activity?.type === 'AT'">
																								<button class="icon-btn"
																									mat-icon-button
																									#editActivityAction
																									(click)="updateActivityAssessment(activity, {
																										actionElement: editActivityAction, index: activityIndex,moduleIndex: i, resource:
																										resourceDetail
																									})">
																									<mat-icon
																										class="remove-icon"
																										svgIcon="edit">
																									</mat-icon>
																								</button>
																							</ng-container>
																							<button class="icon-btn"
																								mat-icon-button
																								#deleteActivityAction
																								(click)="alertPopup('deleteActivity', activity, {
																actionElement: deleteActivityAction, index: activityIndex, moduleIndex: i
															})">
																								<mat-icon
																									class="remove-icon"
																									svgIcon="delete">
																								</mat-icon>
																							</button>
																						</div>
																					</ng-container>
																				</div>
																			</div>
																		</div>
																	</ng-container>
																</div>
															</div>
														</div>
														<ng-container *ngIf="updateActivityPos">
															<div fxLayout="row" fxLayoutAlign="start stretch">
																<div fxFlex="0 1 714px" class="btn-block" fxLayout="row"
																	fxLayoutAlign="center center" fxLayoutGap="18px">
																	<button [disabled]="submitDisable"
																		(click)="updateActivityPosition(data?.activites)"
																		mat-stroked-button class="main-btn"
																		type="button">{{locale.translate('save')}}</button>

																	<button [disabled]="submitDisable"
																		(click)="resetActivityPosition(data?.activites)"
																		mat-button class="cancel-btn"
																		type="button">{{locale.translate('cancel')}}</button>
																</div>
															</div>
														</ng-container>
													</ng-container>
													<ng-container *ngIf="!data?.activites?.length">
														<div fxLayout="column" fxLayoutAlign="center center"
															fxLayoutGap="15px">
															<p class="no-data">{{locale.translate('no_course_content')}}
															</p>
														</div>
													</ng-container>
												</div>
												<ng-container *ngIf="data?.references?.length">
													<div class="reference-block" fxLayout="column"
														fxLayoutAlign="start stretch" fxLayoutGap="10px">
														<div fxLayout="row" fxLayoutAlign="start stretch">
															<div fxFlex="0 1 668px" fxFlex.xs="1 1">
																<app-collapsible-block class="collapsible-block"
																	[data]="{title: locale.translate('references')}"
																	[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
																	radius="5px" color="transparent"
																	borderColor="var(--secondary-three)">

																	<div header-insight class="comp-header">
																		<div fxLayout="row" fxLayoutAlign="start center"
																			fxLayoutAlign.xs="space-between stretch"
																			fxLayoutGap="10px" fxFlex="1 0">

																		</div>
																	</div>
																	<div class="sub-content-area" fxLayout="column"
																		fxLayoutAlign="start stretch" fxLayoutGap="20px"
																		fxLayoutAlign.xs="start stretch">

																		<ng-container
																			*ngFor="let reference of data?.references; trackBy: gfService.trackByID.bind({'key': 'resourceID'});let referenceIndex = index">

																			<div class="updates-content fx-column fx-start-stretch"
																				[ngClass]="{ 'processing': reference?.deleting}">

																				<div
																					class="card-block fx-column fx-start-stretch">
																					<ng-container *ngIf="!['playlist', 'answer','internalEvent',
																						'externalEvent'].includes(reference?.resourceTypeID?.key)">
																						<app-content-image-card
																							[record]="reference"
																							[type]="'minimal'" (remove)="alertPopup('deleteReference', reference, {
																							index: referenceIndex, activityData: data
																							})">
																						</app-content-image-card>
																					</ng-container>
																					<ng-container
																						*ngIf="reference?.resourceTypeID?.key === 'playlist'">
																						<app-playlist-card
																							[data]="reference"
																							[type]="'minimal'" (remove)="alertPopup('deleteReference', reference, {
																							index: referenceIndex, activityData: data
																							})">
																						</app-playlist-card>
																					</ng-container>
																					<ng-container
																						*ngIf="reference?.resourceTypeID?.key === 'answer'">
																						<app-question-card
																							[type]="'minimal'"
																							[data]="reference" (remove)="alertPopup('deleteReference', reference, {
																							index: referenceIndex, activityData: data
																							})">
																						</app-question-card>
																					</ng-container>
																					<ng-container
																						*ngIf="['internalEvent', 'externalEvent'].includes(reference?.resourceTypeID?.key)">
																						<app-event-card
																							[type]="'minimal'"
																							[data]="reference" (remove)="alertPopup('deleteReference', reference, {
																							index: referenceIndex, activityData: data
																							})">
																						</app-event-card>
																					</ng-container>
																				</div>
																			</div>
																		</ng-container>

																	</div>
																</app-collapsible-block>
															</div>
														</div>
													</div>
												</ng-container>
											</app-collapsible-block>
										</div>
									</div>
								</ng-container>
								<!-- </div> -->
							</ng-container>
							<!-- <ng-container *ngIf="assessmentData?.length">
								<ng-container
									*ngFor="let data of assessmentData; trackBy: gfService.trackByID.bind({'key': 'testID'});let i = index">
									<div class="collapsible-block-item" fxLayoutGap="12px">
										<app-collapsible-block class="collapsible-block" [ngClass]="{ 'processing': data?.deleting}"
											[data]="{title:data?.name}"
											[toggle]="{expanded: false, showToggle: true, closedIcon: 'expand_less', expandedIcon: 'expand_more'}"
											radius="5px" color="transparent" borderColor="var(--secondary-three)"
											(opened)="data.opened = $event">

											<div header-insight class="comp-header">
												<div fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="space-between stretch"
													fxLayoutGap="10px" fxFlex="1 0">
													<ng-container *ngIf="data?.opened && canUpdate && canAddModule">
														<button class="icon-btn" mat-stroked-button #takeTestActionEl
															(click)="takeTest(data, takeTestActionEl)">
															Take Test
														</button>
													</ng-container>
													<ng-container
														*ngIf="detectDevice?.resolutionState$?.value?.deviceType === 'desktop' && data?.opened && canUpdate && canAddModule">
														<button class="icon-btn" mat-icon-button #editActionEl
															(click)="updateAssessment(data, editActionEl, {index: i})">
															<mat-icon class="header-icon" svgIcon="edit"></mat-icon>
														</button>
														<button class="icon-btn" mat-icon-button #deleteAction (click)="alertPopup('deleteAssessment', data, {
														actionElement: deleteAction, index: i
													})">
															<mat-icon class="header-icon" svgIcon="delete"></mat-icon>
														</button>
													</ng-container>
													<ng-container
														*ngIf="detectDevice?.resolutionState$?.value?.deviceType !== 'desktop' && data?.opened && canUpdate && canAddModule">
														<button class="icon-btn" mat-icon-button [matMenuTriggerFor]="menu"
															aria-label="Example icon-button with a menu">
															<mat-icon class="header-icon">more_vert</mat-icon>
														</button>
														<mat-menu #menu="matMenu">
															<button mat-menu-item (click)="updateAssessment(data, null, {index: i})">
																<span>Edit</span>
															</button>
															<button mat-menu-item (click)="alertPopup('deleteAssessment', data, {
															index: i
														})">
																<span>Delete</span>
															</button>
														</mat-menu>
													</ng-container>
												</div>
											</div>
											<div class="sub-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px"
												fxLayoutGap.xs="15px" fxLayoutAlign.xs="start stretch">
												<div fxLayout="row wrap" fxLayoutAlign="start stretch">
													<app-chips class="total_qa"
														[data]="{title: locale.translate('duration'), value:data?.duration + ' min'}"
														type="capsule">
													</app-chips>
													<app-chips class="total_qa"
														[data]="{title: locale.translate('points'), value:data?.totalPoints}" type="capsule">
													</app-chips>
													<ng-container *ngIf="data?.autogenerateQuestion">
														<div class="fx-row fx-start-center chk-block">
															<mat-icon class="check-icon">check_box</mat-icon>
															<span class="caption">{{locale.translate('auto_select_questions_at_runtime')}}</span>
														</div>
													</ng-container>
												</div>
												<ng-container *ngIf="data?.description">
													<app-common-view class="caption"
														[data]="{label: locale.translate('description'), value: data?.description}">
													</app-common-view>
												</ng-container>
											</div>
										</app-collapsible-block>
									</div>
								</ng-container>
							</ng-container> -->
						</div>
						<ng-container *ngIf="updateModulePos">
							<div class="btn-block" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="18px">
								<button [disabled]="submitDisable" (click)="updateModulePosition()" mat-stroked-button
									class="main-btn" type="button">{{locale.translate('save')}}</button>

								<button [disabled]="submitDisable" (click)="resetModulePosition()" mat-button
									class="cancel-btn" type="button">{{locale.translate('cancel')}}</button>
							</div>
						</ng-container>
					</ng-container>
					<loader [loader]="loader" [type]="'general'">
					</loader>
				</div>
			</div>
		</app-collapsible-area>
	</div>
</div>
